module.exports = __webpack_public_path__ + "static/media/team17.b59685e7.png";